"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFormPermissions = exports.UserGeneralPermissions = exports.UserScope = exports.UserPermissions = exports.UserRoles = void 0;
var UserRoles;
(function (UserRoles) {
    UserRoles["Owner"] = "Owner";
    UserRoles["Donor"] = "Donor";
    UserRoles["Member"] = "Member";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
/**
 * @deprecated use UserGeneralPermissions or UserFormPermissions
 */
var UserPermissions;
(function (UserPermissions) {
    UserPermissions["Donation"] = "Donation";
    UserPermissions["Ticketing"] = "Ticketing";
    UserPermissions["Contacts"] = "Contacts";
    UserPermissions["UserManagement"] = "UserManagement";
    UserPermissions["Receipt"] = "Receipt";
    UserPermissions["Bank"] = "Bank";
    UserPermissions["TapToPay"] = "TapToPay";
})(UserPermissions || (exports.UserPermissions = UserPermissions = {}));
var UserScope;
(function (UserScope) {
    UserScope["Organization"] = "Organization";
    UserScope["Donor"] = "Donor";
})(UserScope || (exports.UserScope = UserScope = {}));
var UserGeneralPermissions;
(function (UserGeneralPermissions) {
    UserGeneralPermissions["Contacts"] = "Contacts";
    UserGeneralPermissions["UserManagement"] = "UserManagement";
    UserGeneralPermissions["Bank"] = "Bank";
    /**
     * @deprecated.
     */
    UserGeneralPermissions["TapToPay"] = "TapToPay";
})(UserGeneralPermissions || (exports.UserGeneralPermissions = UserGeneralPermissions = {}));
var UserFormPermissions;
(function (UserFormPermissions) {
    UserFormPermissions["ManagePayments"] = "ManagePayments";
    UserFormPermissions["EditForm"] = "EditForm";
    UserFormPermissions["Receipt"] = "Receipt";
    UserFormPermissions["TapToPayPayments"] = "TapToPayPayments";
    UserFormPermissions["TapToPayGuestList"] = "TapToPayGuestList";
})(UserFormPermissions || (exports.UserFormPermissions = UserFormPermissions = {}));
